import { observable } from '@legendapp/state';
import { autoBetState$ } from './auto-bet.state';

export type SessionStatus = 'RUNNING' | 'STOPPED';

type SessionState = {
  status: SessionStatus;
  gameRoundId: string;
  isSessionExpired: boolean;
  expireSession: () => void;
};

export const sessionState$ = observable<SessionState>({
  status: 'STOPPED',
  gameRoundId: '',
  isSessionExpired: false,
  expireSession: () => {
    // Stop autobetting when session expires
    autoBetState$.stopAutoBetting();
    sessionState$.isSessionExpired.set(true);
  },
});
